import { render, staticRenderFns } from "./DxCreateEmployee.vue?vue&type=template&id=4d0e82c8&scoped=true&"
import script from "./DxCreateEmployee.vue?vue&type=script&lang=js&"
export * from "./DxCreateEmployee.vue?vue&type=script&lang=js&"
import style0 from "./DxCreateEmployee.vue?vue&type=style&index=0&id=4d0e82c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0e82c8",
  null
  
)

export default component.exports